import { Component, OnInit, ViewChild } from '@angular/core';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { BusinessProcess } from '../../../../Models/businessProcess';
import { ReportsFilterComponent, ReportFilterType } from '../../../../common/reports-filter/reports-filter.component';
import { InstanceHistoryResultComponent } from '../../../../common/reports-filter/instance-history-result/instance-history-result.component';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-business-process-instance-history',
  templateUrl: './business-process-instance-history.component.html',
  styleUrls: ['./business-process-instance-history.component.css']
})
export class BusinessProcessInstanceHistoryComponent implements OnInit {

  availableBusinessProcess: BusinessProcess[];
  searchType: ReportFilterType.instanceHistory;
  filter: any;
  filterCollapse$: BehaviorSubject<boolean>;
  errorMessage = '';

  @ViewChild('reportsFilterComponent', {static: false}) reportsFilterComponent: ReportsFilterComponent;
  @ViewChild('instanceHistoryResultComponent', {static: false}) instanceHistoryResultComponent: InstanceHistoryResultComponent;

  constructor(
    private bpService: BusinessProcessService
  ) {  }

  ngOnInit() {
    this.loadBusinessProcessList();
    this.filterCollapse$ = new BehaviorSubject(false);
  }

  loadBusinessProcessList() {
    this.errorMessage = '';
    this.bpService.getAllBusinessProcessesPublished()
      .subscribe(
        result => {
          this.availableBusinessProcess = result;
        }, error1 => this.errorMessage = error1
      );
  }

  searchMultipleBusinessProcessInstancesHistory(filter) {
    this.filter = filter;
    this.filterCollapse$.next(true);
  }

}
